import { signOut } from "@homebound/auth-components";
import { Css, HomeboundLogo, Navbar, NavbarProps, NavbarUser, px, TestIds, Tokens, useTestIds } from "@homebound/beam";
import { Link, useLocation } from "react-router-dom";
import { useFeatureFlags } from "src/contexts/FeatureFlags/FeatureFlagContext";
import { FeatureFlagType } from "src/generated/graphqlTypes";
import { useCurrentUser } from "src/hooks/useCurrentUser";
import { buildGlobalNavItems } from "src/routes/layout/global-nav/buildGlobalNavItems";
import { GlobalNavRightSlot } from "src/routes/layout/global-nav/GlobalNavRightSlot";
import { personalDashboardPaths } from "src/routes/routesDef";

export function GlobalNav() {
  const { name, avatar } = useCurrentUser();
  const { pathname } = useLocation();
  const testIds = useTestIds({}, "globalNav");
  const { featureIsEnabled } = useFeatureFlags();

  const navbarProps = getGlobalNavbarProps(name, avatar, pathname, featureIsEnabled, testIds);

  return (
    <div css={Css.fs0.w100.sticky.top0.z999.h(px(topNavHeight)).$} data-testid="globalNavShell">
      <Navbar {...testIds} {...navbarProps} />
    </div>
  );
}

// Intended to be shared by both the above component, and when calling Beam's <NavbarLayout>
export function getGlobalNavbarProps(
  name: string,
  avatar: string,
  pathname: string,
  featureIsEnabled: (flag: FeatureFlagType) => boolean,
  tid: TestIds,
): NavbarProps {
  const items = buildGlobalNavItems(pathname, featureIsEnabled);

  const navbarUser: NavbarUser | undefined = name
    ? {
        name,
        picture: avatar,
        menuItems: [{ label: "Profile", onClick: "https://myaccount.google.com/personal-info" }],
        persistentItems: [
          {
            label: "Sign Out",
            onClick: () => {
              signOut().catch(console.error);
            },
          },
        ],
      }
    : undefined;

  return {
    brand: (
      <Link to={personalDashboardPaths.base} {...tid.homeLink}>
        <HomeboundLogo height={4} fill={Tokens.OnSurface} />
      </Link>
    ),
    hideBrandOnMobile: true,
    items: items,
    rightSlot: <GlobalNavRightSlot />,
    user: navbarUser,
  };
}

export const topNavHeight = 48;
